// src/i18n/I18nLoader.jsx
import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingScreen from '../components/common/LoadingScreen';

// Component that shows translated loading text once i18n is ready
const TranslatedLoadingFallback = () => {
  const { t } = useTranslation();
  return <LoadingScreen text={t('common:messages.loading_languages')} />;
};

// Main I18nLoader component with Suspense
export default function I18nLoader({ children }) {
  return (
    <Suspense fallback={<LoadingScreen text="Loading languages..." />}>
      <Suspense fallback={<TranslatedLoadingFallback />}>
        {children}
      </Suspense>
    </Suspense>
  );
}